import { render, staticRenderFns } from "./HowItWorksPage.vue?vue&type=template&id=2a72f5eb&scoped=true&"
import script from "./HowItWorksPage.vue?vue&type=script&lang=js&"
export * from "./HowItWorksPage.vue?vue&type=script&lang=js&"
import style0 from "./HowItWorksPage.vue?vue&type=style&index=0&id=2a72f5eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a72f5eb",
  null
  
)

export default component.exports